export default {
    SingleCollo: 0,
    MultiCollo: 1,
};
